'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// import {Row, Col} from 'react-flexbox-grid'


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _FlaggedFund = require('./FlaggedFund.css');

var _FlaggedFund2 = _interopRequireDefault(_FlaggedFund);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FlaggedFund = (_dec = (0, _reactCssModules2.default)(_FlaggedFund2.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(FlaggedFund, _Component);

  function FlaggedFund(props) {
    (0, _classCallCheck3.default)(this, FlaggedFund);
    return (0, _possibleConstructorReturn3.default)(this, (FlaggedFund.__proto__ || (0, _getPrototypeOf2.default)(FlaggedFund)).call(this, props));
  }

  (0, _createClass3.default)(FlaggedFund, [{
    key: 'render',
    value: function render() {
      function renderStatCount(tip, count, label) {
        return _react2.default.createElement(
          'div',
          { styleName: 'stat', 'data-multiline': true, 'data-effect': 'solid', 'data-tip': tip },
          _react2.default.createElement(
            'div',
            { styleName: 'stat-count-wrapper' },
            _react2.default.createElement(
              'div',
              { styleName: 'stat-count' },
              count
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'stat-label' },
            ' ',
            label
          )
        );
      }
      var type = this.props.isFamily ? 'family' : 'fund';
      return _react2.default.createElement(
        'div',
        { styleName: 'stats-wrapper' },
        _react2.default.createElement(
          'div',
          { styleName: 'stats' },
          this.props.isFamily ? renderStatCount('Number of funds analyzed from this ' + type, _format2.default.number(this.props.totalFunds), 'FUNDS ANALYZED') : null,
          renderStatCount('Total number of deforestation-risk<br/>stocks we found in this ' + type, _format2.default.number(this.props.count), 'holdings flagged'),
          renderStatCount('Total percent of the ' + type + '\'s long-position assets<br/>invested in deforestation-risk stocks', _format2.default.perc(this.props.weight), 'of assets flagged')
        ),
        _react2.default.createElement(_reactTooltip2.default, null)
      );
    }
  }]);
  return FlaggedFund;
}(_react.Component), _class2.propTypes = {
  count: _react.PropTypes.number.isRequired,
  weight: _react.PropTypes.number.isRequired,
  totalFunds: _react.PropTypes.number,
  isFamily: _react.PropTypes.bool
}, _temp)) || _class);
exports.default = FlaggedFund;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FlaggedFund/FlaggedFund.js
// module id = 1321
// module chunks = 0